import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createManualDiscount = {
  name: "createManualDiscount" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    discountType: createEnum(["percentage", "absolute"]),
    value: z.number().positive(),
  }),
  output: z.object({ discountCode: z.string(), success: z.boolean() }),
};
